import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import store from '@/store/index.js'
import config from '@/config/index.js'

import Home from '@/views/users/Home.vue'
import HomeMobile from '@/views/home/Mobile.vue'
// import Register from '@/views/users/Register.vue'
import Login from '@/views/users/Login.vue'
import Recover from '@/views/users/Recover.vue'
import RecoverShow from '@/views/users/RecoverShow.vue'
import Invitation from '@/views/users/Invitation.vue'
import Public404 from '@/views/public/404.vue'
import PublicTerms from '@/views/public/Terms.vue'
import PublicPrivacy from '@/views/public/Privacy.vue'
// Instance
import InstanceAnalytics from '@/components/instances/PageAnalytics.vue'
// Global
import GlobalLayout from '@/components/layouts/global/Layout.vue'
import GlobalCategories from '@/views/global/Categories.vue'
import GlobalCategoryEdit from '@/views/global/CategoryEdit.vue'
import GlobalSubCategories from '@/views/global/SubCategories.vue'
import GlobalSubCategoryEdit from '@/views/global/SubCategoryEdit.vue'
import GlobalSongEdit from '@/views/global/SongEdit.vue'
import GlobalInstrumentEdit from '@/views/global/InstrumentEdit.vue'
import GlobalProducts from '@/views/global/Products.vue'
import GlobalPlans from '@/views/global/Plans.vue'
import GlobalPlanEdit from '@/views/global/PlanEdit.vue'
import GlobalAudios from '@/views/global/Audios.vue'
import GlobalGuides from '@/views/global/Guides.vue'
import GlobalInfos from '@/views/global/Infos.vue'
import GlobalLanding from '@/views/global/Landing.vue'
import StatisticsAtk from '@/views/global/statistics/Atk.vue'
import StatisticsBrands from '@/views/global/statistics/Brands.vue'
// Super
import SuperLayout from '@/components/layouts/super/Layout.vue'
// Admin
import AdminBrands from '@/views/admin/Brands.vue'
import AdminInvitations from '@/views/admin/Invitations.vue'
import AdminBrandProducts from '@/views/admin/Products.vue'
import AdminProductEdit from '@/views/admin/ProductEdit.vue'
import AdminBrandInstances from '@/views/admin/Instances.vue'
import AdminInstanceEdit from '@/views/admin/InstanceEdit.vue'
import AdminCustomers from '@/views/admin/Customers.vue'
import AdminTooltips from '@/views/admin/Tooltips.vue'
import AdminCustomerEdit from '@/views/admin/CustomerEdit.vue'
// Client
import ClientLayout from '@/components/layouts/client/Layout.vue'
import ClientProducts from '@/views/client/Products.vue'
import ClientProductEdit from '@/views/client/ProductEdit.vue'
import ClientInstances from '@/views/client/Instances.vue'
import ClientInstanceEdit from '@/views/client/InstanceEdit.vue'
import ClientProfile from '@/views/client/Profile.vue'
import ClientIntegration from '@/views/client/Integration.vue'
import ClientGuide from '@/views/client/Guide.vue'
// ATK Mobile
import AtkLayout from '@/components/layouts/atk/Layout.vue'
import AtkInstances from '@/views/atk/instances/Index.vue'
import AtkInstanceEdit from '@/views/atk/instances/Edit.vue'
import AtkLanding from '@/views/atk/settings/Landing.vue'
import AtkRetailers from '@/views/atk/retailers/Index.vue'
import AtkInfos from '@/views/atk/settings/Infos.vue'
import AtkStatisticsProducts from '@/views/atk/statistics/Products.vue'

const routes = [
  {
    path: '/',
    redirect: '/home',
    name: 'root'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/mobile',
    name: 'HomeMobile',
    component: HomeMobile
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/recover',
    name: 'Recover',
    component: Recover
  },
  {
    path: '/recover/:uuid',
    name: 'RecoverShow',
    component: RecoverShow
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: Register
  // },
  {
    path: '/invitations/:uuid',
    name: 'Invitation',
    component: Invitation
  },
  {
    path: '/terms',
    name: 'PublicTerms',
    component: PublicTerms
  },
  {
    path: '/privacy',
    name: 'PublicPrivacy',
    component: PublicPrivacy
  },
  {
    path: '/global',
    component: GlobalLayout,
    meta: {
      isGlobal: true,
      authGlobal: true,
      currentRole: 'global'
    },
    children: [
      {
        path: '',
        redirect: '/global/brands',
        name: 'Global'
      },
      {
        path: 'customers',
        component: AdminCustomers,
        name: 'GlobalCustomers',
        meta: {
          currentTab: 'customers'
        }
      },
      {
        path: 'customers/:id/edit',
        component: AdminCustomerEdit,
        name: 'GlobalCustomerEdit',
        meta: {
          currentTab: 'customers'
        }
      },
      {
        path: 'brands',
        component: AdminBrands,
        name: 'GlobalBrands',
        meta: {
          currentTab: 'brands'
        }
      },
      {
        path: 'invitations',
        component: AdminInvitations,
        name: 'GlobalInvitations',
        meta: {
          currentTab: 'invitations'
        }
      },
      {
        path: 'brands/:adminBrandId/products',
        component: AdminBrandProducts,
        name: 'GlobalBrandProducts',
        meta: {
          currentTab: 'brand_products'
        }
      },
      {
        path: 'brands/:adminBrandId/products/:id/edit',
        component: AdminProductEdit,
        name: 'GlobalBrandProductEdit',
        meta: {
          currentTab: 'brand_products'
        }
      },
      {
        path: 'brands/:adminBrandId/instances',
        component: AdminBrandInstances,
        name: 'GlobalBrandInstances',
        meta: {
          currentTab: 'brand_instances'
        }
      },
      {
        path: 'brands/:adminBrandId/instances/:id/edit',
        component: AdminInstanceEdit,
        name: 'GlobalBrandInstanceEdit',
        meta: {
          currentTab: 'brand_instances'
        }
      },
      {
        path: 'brands/:adminBrandId/instances/:id/analytics',
        component: InstanceAnalytics,
        name: 'GlobalBrandInstanceAnalytics',
        meta: {
          currentTab: 'brand_instances'
        }
      },
      {
        path: 'categories',
        component: GlobalCategories,
        name: 'GlobalCategories',
        meta: {
          currentTab: 'categories'
        }
      },
      {
        path: 'categories/:id/edit',
        component: GlobalCategoryEdit,
        name: 'GlobalCategoryEdit',
        meta: {
          currentTab: 'categories'
        }
      },
      {
        path: 'sub_categories',
        component: GlobalSubCategories,
        name: 'GlobalSubCategories',
        meta: {
          currentTab: 'sub_categories'
        }
      },
      {
        path: 'sub_categories/:id/edit',
        component: GlobalSubCategoryEdit,
        name: 'GlobalSubCategoryEdit',
        meta: {
          currentTab: 'sub_categories'
        }
      },
      {
        path: 'songs/:id/edit',
        component: GlobalSongEdit,
        name: 'GlobalSongEdit',
        meta: {
          currentTab: 'sub_categories'
        }
      },
      {
        path: 'instruments/:id/edit',
        component: GlobalInstrumentEdit,
        name: 'GlobalInstrumentEdit',
        meta: {
          currentTab: 'sub_categories'
        }
      },
      {
        path: 'products',
        component: GlobalProducts,
        name: 'GlobalAllProducts',
        meta: {
          currentTab: 'products'
        }
      },
      {
        path: 'products/:id/edit',
        component: AdminProductEdit,
        name: 'GlobalProductEdit',
        meta: {
          currentTab: 'products'
        }
      },
      {
        path: 'plans',
        component: GlobalPlans,
        name: 'GlobalPlans',
        meta: {
          currentTab: 'plans'
        }
      },
      {
        path: 'plans/:id/edit',
        component: GlobalPlanEdit,
        name: 'GlobalPlanEdit',
        meta: {
          currentTab: 'plans'
        }
      },
      {
        path: 'audios',
        component: GlobalAudios,
        name: 'GlobalAudios',
        meta: {
          currentTab: 'audios'
        }
      },
      {
        path: 'guides',
        component: GlobalGuides,
        name: 'GlobalGuides',
        meta: {
          currentTab: 'guides'
        }
      },
      {
        path: 'infos',
        component: GlobalInfos,
        name: 'GlobalInfos',
        meta: {
          currentTab: 'infos'
        }
      },
      {
        path: 'landing',
        component: GlobalLanding,
        name: 'GlobalLanding',
        meta: {
          currentTab: 'landing'
        }
      },
      {
        path: 'statistics/atk',
        component: StatisticsAtk,
        name: 'StatisticsAtk',
        meta: {
          currentTab: 'statistics_atk'
        }
      },
      {
        path: 'statistics/brands',
        component: StatisticsBrands,
        name: 'StatisticsBrands',
        meta: {
          currentTab: 'statistics_brands'
        }
      }
    ]
  },
  {
    path: '/super',
    component: SuperLayout,
    meta: {
      isSuper: true,
      authSuper: true,
      currentRole: 'super'
    },
    children: [
      {
        path: '',
        redirect: '/super/brands',
        name: 'Super'
      },
      {
        path: 'customers',
        component: AdminCustomers,
        name: 'SuperCustomers',
        meta: {
          currentTab: 'customers'
        }
      },
      {
        path: 'customers/:id/edit',
        component: AdminCustomerEdit,
        name: 'SuperCustomerEdit',
        meta: {
          currentTab: 'customers'
        }
      },
      {
        path: 'tooltips',
        component: AdminTooltips,
        name: 'SuperTooltips',
        meta: {
          currentTab: 'tooltips'
        }
      },
      {
        path: 'brands',
        component: AdminBrands,
        name: 'SuperBrands',
        meta: {
          currentTab: 'brands'
        }
      },
      {
        path: 'invitations',
        component: AdminInvitations,
        name: 'SuperInvitations',
        meta: {
          currentTab: 'invitations'
        }
      },
      {
        path: 'brands/:adminBrandId/products',
        component: AdminBrandProducts,
        name: 'SuperBrandProducts',
        meta: {
          currentTab: 'brand_products'
        }
      },
      {
        path: 'brands/:adminBrandId/products/:id/edit',
        component: AdminProductEdit,
        name: 'SuperBrandProductEdit',
        meta: {
          currentTab: 'brand_products'
        }
      },
      {
        path: 'brands/:adminBrandId/instances',
        component: AdminBrandInstances,
        name: 'SuperBrandInstances',
        meta: {
          currentTab: 'brand_instances'
        }
      },
      {
        path: 'brands/:adminBrandId/instances/:id/edit',
        component: AdminInstanceEdit,
        name: 'SuperInstanceEdit',
        meta: {
          currentTab: 'brand_instances'
        }
      }
    ]
  },
  {
    path: '/client',
    component: ClientLayout,
    meta: {
      isClient: true,
      authClient: true,
      currentRole: 'client'
    },
    children: [
      {
        path: '',
        redirect: '/client/products',
        name: 'Client'
      },
      {
        path: 'integration',
        component: ClientIntegration,
        name: 'ClientIntegration',
        meta: {
          currentTab: 'integration'
        }
      },
      {
        path: 'guide',
        component: ClientGuide,
        name: 'ClientGuide',
        meta: {
          currentTab: 'guide'
        }
      },
      {
        path: 'profile',
        component: ClientProfile,
        name: 'ClientProfile',
        meta: {
          currentTab: 'profile'
        }
      },
      {
        path: 'products',
        component: ClientProducts,
        name: 'ClientProducts',
        meta: {
          currentTab: 'products'
        }
      },
      {
        path: 'products/:id/edit',
        component: ClientProductEdit,
        name: 'ClientProductEdit',
        meta: {
          currentTab: 'products'
        }
      },
      {
        path: 'instances',
        component: ClientInstances,
        name: 'ClientInstances',
        meta: {
          currentTab: 'instances'
        }
      },
      {
        path: 'instances/:id/edit',
        component: ClientInstanceEdit,
        name: 'ClientInstanceEdit',
        meta: {
          currentTab: 'instances'
        }
      }
    ]
  },
  {
    path: '/atk',
    component: AtkLayout,
    meta: {
      isAtk: true,
      authAtk: true,
      currentRole: 'atk'
    },
    children: [
      {
        path: '',
        redirect: '/atk/instances',
        name: 'Atk'
      },
      {
        path: 'instances',
        component: AtkInstances,
        name: 'AtkInstances',
        meta: {
          currentTab: 'instances'
        }
      },
      {
        path: 'instances/:id/edit',
        component: AtkInstanceEdit,
        name: 'AtkInstanceEdit',
        meta: {
          currentTab: 'instances'
        }
      },
      {
        path: 'landing',
        component: AtkLanding,
        name: 'AtkLanding',
        meta: {
          currentTab: 'landing'
        }
      },
      {
        path: 'infos',
        component: AtkInfos,
        name: 'AtkInfos',
        meta: {
          currentTab: 'infos'
        }
      },
      {
        path: 'retailers',
        component: AtkRetailers,
        name: 'AtkRetailers',
        meta: {
          currentTab: 'retailers'
        }
      },
      {
        path: 'statistics/products',
        component: AtkStatisticsProducts,
        name: 'AtkStatisticsProducts',
        meta: {
          currentTab: 'statistics_products'
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: Public404,
    name: '404'
  }
]

const router = createRouter({
  history: createWebHistory(config.basePath),
  routes
})

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const userToken = getToken()
  const isGlobal = to.matched.some(r => r.meta.isGlobal)
  const authGlobal = to.matched.some(r => r.meta.authGlobal)
  const isSuper = to.matched.some(r => r.meta.isSuper)
  const authSuper = to.matched.some(r => r.meta.authSuper)
  const isClient = to.matched.some(r => r.meta.isClient)
  const authClient = to.matched.some(r => r.meta.authClient)
  const isAtk = to.matched.some(r => r.meta.isAtk)
  const authAtk = to.matched.some(r => r.meta.authAtk)
  const { currentTab, currentRole } = to.meta

  if (isSuper || isClient || isGlobal || isAtk) {
    await store.dispatch('setCurrentTab', currentTab)
    await store.dispatch('setCurrentRole', currentRole)
    if (!userToken) {
      next(`/login?redirect=${to.path}`)
    } else {
      let userInfo = store.state.userInfo
      if (!userInfo.role) {
        userInfo = await store.dispatch('getUserInfo').catch(err => {
          console.error('getUserInfo', err)
        })
      }
      if (!userInfo) userInfo = {}
      const adminBrandId = to.params.adminBrandId
      if (adminBrandId) {
        await store.dispatch('getAdminBrand', adminBrandId).catch(err => {
          console.error('getAdminBrand', err)
        })
      } else {
        await store.dispatch('clearAdminBrand')
      }
      switch (userInfo.role) {
        case 'global_admin':
          if (authGlobal) {
            next()
          } else {
            await store.dispatch('setCurrentTab', 'brands')
            await store.dispatch('setCurrentRole', 'global')
            next('/global')
          }
          break
        case 'super_admin':
          if (authSuper) {
            next()
          } else {
            await store.dispatch('setCurrentTab', 'brands')
            await store.dispatch('setCurrentRole', 'super')
            next('/super')
          }
          break
        case 'customer':
          if (authClient) {
            next()
          } else {
            next('/client')
          }
          break
        case 'atk':
          if (authAtk) {
            next()
          } else {
            next('/atk')
          }
          break
        default:
          store.dispatch('logout')
          next('/login')
      }
    }
  } else {
    next()
  }
})

// 简单配置  进度条
NProgress.configure({ easing: 'ease', speed: 500 })
router.afterEach(transition => {
  NProgress.done()
})

export default router
